module.exports = __webpack_public_path__ + "img/stamp_drag_off.02e7ccd0.svg";